import React, { useState,useEffect } from "react";
import "./Sidebar.css";
import ChatIcon from "@mui/icons-material/Chat";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import {Avatar,IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { SearchOutlined } from "@mui/icons-material";
import SidebarChat from "./SidebarChat";
import axios from "./axios";
import Pusher from "pusher-js";
import {useStateValue} from "./StateProvider";


function Sidebar() {

  
  const [{user},dispatch]=useStateValue();

  const [rooms,setRooms]=useState([]);
  const [seed, setSeed] = useState("");
  const [search, setSearch] = useState("");

//   const filterRooms = rooms.filter(room=>{
//     return room.name.toLowerCase().includes(search.toLowerCase());
// });

  useEffect(() => {
    setSeed(Math.floor(Math.random() * 5000));
  }, []);
  useEffect(() => {
    axios.get('/rooms/sync')
    .then(res => {
      // console.log(res.data);
        setRooms(res.data);
    })
}, [])


  useEffect(() => {
    var pusher2 = new Pusher("99034683c1429eea8d6f", {
      cluster: "ap2",
    });

    var channel2 = pusher2.subscribe("rooms");
    channel2.bind("inserted", function (data) {
      
      setRooms([...rooms,data])
      // alert(JSON.stringify(data));
    });

    return ()=>{
      channel2.unbind_all();
      channel2.unsubscribe();
    }
  }, [rooms]);
  // console.log(data)
  const createRoom=async e=>{
    e.preventDefault();
    const roomName=prompt("please enter the room name you want to create");
 if(roomName){
    axios.post("/rooms/new",{
      message:"hi new message",
      name:roomName,
      
    });
    window.location.reload(true);
  }
    
     
  }



  return (
    <div className="sidebar">
      <div className="sidebar_header">
      <Avatar src={user?.photoURL} />
        <div className="sidebar_headerRight">
          <IconButton>
            <DonutLargeIcon />
          </IconButton>
          <IconButton onClick={createRoom}>
            <ChatIcon />
          </IconButton>
          <IconButton>
            <MoreVertIcon />
          </IconButton>
        </div>
      </div>
      <div className="sidebar_search">
        <div className="sidebar_searchContainer">
          <SearchOutlined />
          <input placeholder="Search or start new chat" type="text" />
        </div>
      </div>
      <div className="sidebar_chat">
      <SidebarChat addNewChat />
      {rooms.map(room =>(
         <SidebarChat key={room._id} name={room.name} id={room._id} image={room.image}  />
      ))}
        {/* 
        <SidebarChat  />
        <SidebarChat  /> */}
      </div>
    </div>
  );
}

export default Sidebar;
